import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { Settlement } from 'src/app/models/settlement.model';
import { Unit } from 'src/app/models/unit.model';
import { BreadcrumbService } from 'xng-breadcrumb';
import { environment } from 'src/environments/environment';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-create-settlement',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Clientes</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-settlements [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">{{ type === '1' ? 'Comercial' : 'Condominios' }}</h2>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <app-form-settlement 
              [settlement]="settlement" 
              [profile]="profile"
              [permissions]="permissions"
            ></app-form-settlement>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class CreateSettlementComponent {
  apiUrl: string = environment.AWS_REST_WSPREFIX;
  units: Unit[] = [];
  settlement: Settlement | null = null;
  permissions: any = {};
  // buildings: any[] = [];
  // floors: any[] = [];
  // color: any = "";

  currentView: string = 'condominios';

  loading: boolean = false;
  imageURL: any = '';

  imageError: string = "";
  isImageSaved: boolean = false;
  cardImageBase64: string = "";
  previewImagePath: string = "";

  settlementForm: FormGroup = new FormGroup({});

  profile: any = {};

  availZones: any[] = [];

  faInfoCircle = faInfoCircle;
  faCircleNotch = faCircleNotch;
  faChevronLeft = faChevronLeft;
  type: string = '';
  utility_id: number = 1;

  // 1 = WEEKLY 2 = BIWEEKLY 3 = MONTHLY 4 = BIMONTHLY 5 = QUARTERLY 6 = SEMIANNUAL 7 = ANNUAL
  periodicity: any[] = [
    { id: 1, name: 'Semanal' },
    { id: 2, name: 'Quincenal' },
    { id: 3, name: 'Mensual' },
  ]

  weekDays: any[] = [
    { id: 1, name: 'Lunes' },
    { id: 2, name: 'Martes' },
    { id: 3, name: 'Miércoles' },
    { id: 4, name: 'Jueves' },
    { id: 5, name: 'Viernes' },
    { id: 6, name: 'Sábado' },
    { id: 7, name: 'Domingo' },
  ];

  cpResults: any[] = [];
  regionControl = new FormControl();
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private route: Router,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private breadcrumbService: BreadcrumbService,
  ) {
    this.loading = true;
    this.profile = this.storageService.getItem(STORAGE_KEYS.PROFILE) ? this.storageService.getItem(STORAGE_KEYS.PROFILE).profile : null;
    this.permissions = this.storageService.getItem(STORAGE_KEYS.PERMISSIONS);
    console.log("PROFILE ====> ", this.profile);
    this.activatedRoute.params.subscribe((params: any) => {
      this.loading = false;
      console.log("params ======");
      console.log(params);
      if (params['id'] != 'create') {
        /*this.store.getSettlement(params['id']).subscribe({
          next: (data: any) => {
            this.settlement = data;
            this.settlementForm.patchValue(data);
            this.color = data.code;
            this.loading = false;

            this.settlementForm.patchValue({
              utility_id: this.profile.profile.utility_id
            });

            if (data.image) {
              this.imageURL = `${this.apiUrl}/storage/${data.image?.blob.key.substring(0,2)}/${data.image?.blob.key.substring(2,4)}/${data.image?.blob.key}`;
            }
          },
          error: (error: any) => {
            console.log(error);
            this.loading = false;
          }
        });*/
      }

      // this.settlementForm.patchValue({
        // utility_id: this.profile.profile.utility_id
      // });

      console.log(this.profile.utility_id);
      this.utility_id = this.profile.utility_id;
      if (this.route.url == '/comercials/create' || this.route.url == '/condominios/create/comercio') {
        this.type = '1';
      } else if (this.route.url == '/condominios/create/condominio') {
        this.type = '0';
      }
      // if (params['type']) {
        // this.type = params['type'];
      // }
    });
  }

  ngOnInit(): void {
    // this.buildSettlementForm();
    // this.loadZones();
    let nombreB = this.type == '0' ? 'Condominio' : 'Comercio';
    this.breadcrumbService.set('@ChildOne', `Crear ${nombreB}`);

    this.regionControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap(query => this.store.getTenantRegions(query))
    ).subscribe((results: any) => {
      console.log('RESULTS ==> ', results);
      this.cpResults = results;
    });
  }

  selectCP(result: any) {
    this.settlementForm.patchValue({
      zip: result.postalCode,
      city: result.city,
      state: result.state,
      region_id: result.id,
      country: result.country
    });

    this.cpResults = [];
  }

  buildSettlementForm() {
    this.settlementForm = this.fb.group({
      name: ['', Validators.required],
      address: [''],
      outer_number: [''],
      phone: [''],
      email: [''],
      name_admin: [''],
      website: [''],
      description: [''],
      slug: [''],
      code: [''],
      factor: ['', Validators.required],
      admin_price: ['', Validators.required],
      discount: ['', Validators.required],
      interests: ['', Validators.required],
      invoice_limit: [''],
      reconexion_fee: ['', Validators.required],
      periodicity: ['', Validators.required],
      cycle_day: ['', Validators.required],
      country: [''],
      city: [''],
      state: [''],
      zip: [''],
      identificacion: [''],
      contrato: [''],
      vigencia: [''],
      logo: [''],
      tipo: [0],
      latitude: [''],
      longitude: [''],
      utility_id: [''],
      zone_id: [''],
      corte: [''],
      tampering_fine: [''],
      merchant_id: [''],
      bank_clabe: [''],
      bank_name: [''],
      credit: [''],
    });
  }

  get sfc () {
    return this.settlementForm.controls;
  }

  loadZones() {
    console.log("PROFILEXXXXX ===> ", this.profile.profile.utility_id);
    this.store.getUtilitySettings({ utility_id: this.profile.profile.utility_id }).subscribe((data: any) => {
      console.log("ZONE =====> ", data.data);
      let zones: any = data.data;
      zones.map((zone: any) => {
        console.log("zone => ", zone.zone_id);
        if (zone.zone_id) {
          console.log("ABLE TO PUSH");
          this.store.getZone(zone.zone_id).subscribe((data: any) => {
            console.log("ZONE DATA =====> ", data);
            this.availZones.push(data);
          });
        }        
      });

      // console.log("ZONES AVAILABLE =======> ", this.availZones);
    });
  }

  /*loadImage(event: any): void {
    this.imageError = "";

    if (event.target.files && event.target.files[0]) {
      // Size Filter Bytes
      const max_size = 20971520;
      const allowed_types = ['image/png'];
      const max_height = 15200;
      const max_width = 25600;

      if (event.target.files[0].size > max_size) {
        this.imageError = 'Maximum size allowed is ' + max_size / 1000 + 'Mb';
        // return false;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = (rs: any): void => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];
          // console.log(img_height, img_width);
          if (img_height > max_height && img_width > max_width) {
            this.imageError = 'Maximum dimentions allowed ' + max_height + '*' + max_width + 'px';
            // return false;
          } else {
            const imgBase64Path = e.target.result;
            this.cardImageBase64 = imgBase64Path;
            this.isImageSaved = true;
            this.previewImagePath = imgBase64Path;
            console.log('imgBase64Path => ', imgBase64Path);
            console.log('previewImagePath => ', this.previewImagePath);
            let payload = {
              id: this.settlement?.id,
              data: this.previewImagePath
            }
            // console.log('event => ', event.target.files[0]);
            this.store.updateSettlementImage(this.settlement?.id, payload).subscribe((data: any) => {
              console.log('data => ', data);
              this.toastr.success('Se actualizó la imagen correctamente.', 'Éxito');
              // this.loadUser(this.userId);
            });
          }
        };
      };

      reader.readAsDataURL(event.target.files[0]);
    }
  }*/

  loadPDF(event: any): void {
    const reader = new FileReader();
    const ctl = this;
    var base64;
    var fileToLoad = event.target.files[0];
    reader.onload = function(fileLoadedEvent) {
      base64 = fileLoadedEvent.target!.result;
      // Print data in console
      console.log(base64);
      ctl.settlementForm.patchValue({
        contrato: base64
      });
    };
    // Convert data to base64
    reader.readAsDataURL(fileToLoad);
  }


  updateColor(e: any): void {
    console.log(e.target);
    this.settlementForm.patchValue({
      code: e.target.value
    });
  }

  /*updateSettlement() {
    this.loading = true;
    this.settlementForm.patchValue({
      code: this.color,
      tipo: this.type,
      utility_id: this.utility_id
    });
    
    console.log(this.settlementForm.value);

    if (this.settlementForm.invalid) {
      this.settlementForm.markAllAsTouched()
      this.toastr.error('No está completa la información.', 'Error');
      this.loading = false;
      //
      return;
    }

    this.store.createSettlement(this.settlementForm.value).subscribe({
      next: (data: any) => {
        this.toastr.success('Se ha creado el condominio.', 'Éxito');
        this.loading = false;
        if (this.type == '0') {
          this.route.navigate(['/condominios']);
        } else {
          this.route.navigate(['/comercials']);
        }
      },
      error: (e: any) => {
        this.toastr.error(`Ocurrió un error por favor intenta de nuevo más tarde. \n ${e}`, 'Error');
        this.loading = false;
      }     
    });
  }*/
}
